export function RecordsDisclaimer({ className }: { className?: string }) {
  return (
    <p className={['text-xs text-muted-foreground leading-relaxed', className].filter(Boolean).join(' ')} data-testid="records-disclaimer">
      <strong className="text-foreground">Records only. We do not file.</strong> Not a CPA, bank, or tax-filing service.
      Not tax, legal, or investment advice. Meals are recorded in full; any limit is a filing decision made elsewhere.
    </p>
  );
}

export default RecordsDisclaimer;
